import { useEffect, useState } from 'react';

import { VersionReviewDialog } from '../../../components/VersionReviewDialog/index.js';
import type { AgentVersion } from '../../../types/agent.js';
import { AgentForm } from '../AgentForm/AgentForm.js';

export interface VersionSnapshotDialogProps {
  version: AgentVersion | null;
  onClose: () => void;
}

export function VersionSnapshotDialog({
  version,
  onClose,
}: VersionSnapshotDialogProps) {
  const [shown, setShown] = useState<AgentVersion | null>(version);
  useEffect(() => {
    if (version !== null) setShown(version);
  }, [version]);

  return (
    <VersionReviewDialog
      open={version !== null}
      title={
        shown ? `${shown.name} — version ${String(shown.version)}` : 'Version'
      }
      onClose={onClose}
    >
      {shown && <AgentForm mode="view" initialAgent={shown} />}
    </VersionReviewDialog>
  );
}
